import { apiClient } from '@/shared/api';

import type {
  AttributeGroup,
  AttributeGroupCreateRequest,
  AttributeGroupUpdateRequest,
} from '../model/types';

const BASE = '/api/v1/catalog/attribute-groups';

/**
 * List the tenant's attribute groups (plan-catalog-009, user-story-catalog-024) — the display
 * grouping an attribute's `groupCode` references, e.g. "Technical specifications".
 */
export const listAttributeGroups = async (): Promise<AttributeGroup[]> =>
  (await apiClient.get<AttributeGroup[]>(BASE)).data;

export const getAttributeGroup = async (code: string): Promise<AttributeGroup> =>
  (await apiClient.get<AttributeGroup>(`${BASE}/${encodeURIComponent(code)}`)).data;

export const createAttributeGroup = async (
  body: AttributeGroupCreateRequest,
): Promise<AttributeGroup> => (await apiClient.post<AttributeGroup>(BASE, body)).data;

export const updateAttributeGroup = async (
  code: string,
  body: AttributeGroupUpdateRequest,
): Promise<AttributeGroup> =>
  (await apiClient.patch<AttributeGroup>(`${BASE}/${encodeURIComponent(code)}`, body)).data;

/** Rejected with `409 ATTRIBUTE_GROUP_IN_USE` while an attribute still references this group. */
export const deleteAttributeGroup = async (code: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
};
